export const STORE_KEY = 'gic-smart-fields-feature';
export const SMART_FIELDS_ADMIN_TOGGLE_APP_PROPERTY_KEY = 'jira.create.smart.fields.is-enabled';
